angular.module('hjApp.tracking', [
    'ui.router',
    'angulartics',
    'angulartics.google.analytics',
    'hjApp.user',
    'hjApp.plans',
    'hjApp.revenue'
]);
